import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { motion } from 'framer-motion';

const ASSETS = {
  full: '/brand/logo.png',
  letters: '/brand/logo-letters.png',
  accent: '/brand/logo-accent.png',
  drop: '/brand/logo-drop.png',
};

export const LOGO_RATIO = 1073 / 592;

interface LogoProps extends Omit<BoxProps, 'height'> {
  /** rendered height in px */
  height?: number;
  /** share a layoutId so the splash logo can fly into the header */
  layoutId?: string;
  /** stack the three colour layers so they can be animated separately */
  layered?: boolean;
}

/**
 * The Nadeem word-mark. Uses the transparent PNG cut from the brand file.
 * `layered` renders letters / accent / drop as separate absolutely-positioned
 * images so callers can animate each part.
 */
const Logo: React.FC<LogoProps> = ({ height = 36, layoutId, layered = false, sx, ...rest }) => {
  const width = Math.round(height * LOGO_RATIO);
  const Wrapper: any = layoutId ? motion.div : 'div';
  return (
    <Box
      component={Wrapper}
      {...(layoutId ? { layoutId } : {})}
      sx={{ position: 'relative', width, height, flexShrink: 0, display: 'inline-block', ...sx }}
      {...rest}
    >
      {layered ? (
        <>
          <img src={ASSETS.letters} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
          <img src={ASSETS.accent} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
          <img src={ASSETS.drop} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
        </>
      ) : (
        <img src={ASSETS.full} alt="Nadeem · نديم" style={{ width: '100%', height: '100%', display: 'block' }} />
      )}
    </Box>
  );
};

export { ASSETS as LOGO_ASSETS };
export default Logo;
